<span [class]="isCompleted() ? 'line-through' : ''">{{ title }}</span>
